import SpacesTimeline from "./SpacesTimeline";
import SpaceMembers from "./SpaceMembers";
import SpacesScheduledTimeline from "./SpacesScheduledTimeline";
import EditSpaceInvitation from "../EditSpaceInvitation";

export const spaceRoutes = [
  {
    path: "/spaces/:id",
    exact: true,
    component: SpacesTimeline,
  },
  {
    path: "/spaces/:id/members",
    exact: true,
    component: SpaceMembers,
  },
  {
    path: "/spaces/:id/schedule",
    exact: true,
    component: SpacesScheduledTimeline,
  },
  {
    path: "/spaces/:spaceId/invitations/:invitationId/edit",
    exact: true,
    component: EditSpaceInvitation,
  },
];
